module.exports = __webpack_public_path__ + "static/media/white-trendex-new-loader.7b14cf07.gif";